export type GetTenantSettingValuesApiResponse = /** status 200  */ TenantSettingValueResponseBody[];
export type GetTenantSettingValuesApiArg = {
  settingId: string;
};
export type SetTenantSettingValueApiResponse = unknown;
export type SetTenantSettingValueApiArg = {
  settingId: string;
  valueRequestBody: ValueRequestBody;
};
export type RecordIdResponseBody = {
  id: string;
  resourceId: string;
};
export type TenantSettingValueResponseBody = {
  tenantId: string;
  value: any | null; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  force: boolean;
  recordId?: RecordIdResponseBody | null;
};
export type RecordIdRequestBody = {
  id: string;
  resourceId: string;
};
export type ValueRequestBody = {
  value: any | null; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  force: boolean;
  recordId?: RecordIdRequestBody | null;
};

export type ClearBranchValueApiResponse = /** status 204  */ void;
export type ClearBranchValueApiArg = {
  branchId: string;
  settingId: string;
  resourceId: string;
  recordId: string;
};
export type ClearBranchValueWithoutReferenceApiResponse = /** status 204  */ void;
export type ClearBranchValueWithoutReferenceApiArg = {
  branchId: string;
  settingId: string;
};
export type GetBranchSettingValuesApiResponse = /** status 200  */ BranchSettingValueResponseBody[];
export type GetBranchSettingValuesApiArg = {
  settingId: string;
};
export type SetBranchSettingValueApiResponse = /** status 204  */ void;
export type SetBranchSettingValueApiArg = {
  settingId: string;
  branchId: string;
  valueRequestBody: ValueRequestBody;
};

export type BranchSettingValueResponseBody = {
  branchId: string;
  value: any | null; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  force: boolean;
  recordId?: RecordIdResponseBody | null;
};
export type ClearTenantValueWithoutReferenceApiResponse = /** status 204  */ void;
export type ClearTenantValueWithoutReferenceApiArg = {
  settingId: string;
};

export type GetEffectiveValueApiResponse = /** status 200  */ Record<string, any>; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
export type GetEffectiveValueApiArg = {
  settingId: string;
  resourceId: string;
  recordId: string;
};
export type GetEffectiveValueWithoutReferenceApiResponse = /** status 200  */ Record<string, any>; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
export type GetEffectiveValueWithoutReferenceApiArg = {
  settingId: string;
};
